import React, { Component } from 'react'
import { observer } from 'mobx-react'
import * as R from 'ramda'

import Modal from '@UniformComponents/Modal'
import Button from '@UniformComponents/Button'
import ModalFooter from '@UniformComponents/ModalFooter'
import Input from '@Form/Input'

@observer
class Test extends Component {
    constructor(props) {
        super(props)

        this.state = {
            surveyId: '',
            kpiValue: undefined,
        }
    }

    testKpi = async () => {
        const { store, kpi } = this.props
        const { surveyId } = this.state

        if (R.isEmpty(surveyId)) return

        const result = await store.testKpi(surveyId, kpi)

        this.setState({
            kpiValue: result,
        })
    }

    renderKpiResult = () => {
        const { kpi } = this.props
        const { kpiValue } = this.state

        if (R.isNil(kpiValue)) return null

        const { kpiId } = kpi

        const variableData = R.pathOr({}, [0, 'variableData'], kpiValue)

        return (
            <div
                style={{
                    marginTop: '10px',
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '15px',
                }}
            >
                <div
                     style={{
                        marginTop: '10px',
                        display: 'flex',
                        flexDirection: 'column',
                        gap: '5px',
                    }}
                >
                    <h5>Variables</h5>
                    <div
                        style={{
                            marginTop: '10px',
                            display: 'flex',
                            flexDirection: 'column',
                            gap: '5px',
                        }}
                    >
                        {Object.entries(variableData).map(([k, v]) => (
                            <div
                                style={{
                                    display: 'flex',
                                    gap: "10px",
                                }}
                            >
                                <span>{k}</span>
                                <span>=</span>
                                <span>{v}</span>
                            </div>
                        ))}
                    </div>
                </div>
                
                <div
                    style={{
                        marginTop: '10px',
                        display: 'flex',
                        flexDirection: 'column',
                        gap: '15px',
                    }}
                >
                    <h5>Options</h5>
                    <div
                        style={{
                            marginTop: '10px',
                            display: 'flex',
                            flexDirection: 'column',
                            gap: '5px',
                        }}
                    >
                        {kpiValue.map(({ name, score }) => (
                            <div
                                style={{
                                    display: 'flex',
                                    gap: "10px",
                                }}
                            >
                                <span>
                                    {R.or(name, '')}
                                </span>
                                <span>=</span>
                                <span>{score}</span>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        )
    }

    render() {
        const { store } = this.props

        return (
            <Modal
                show={store.showTest}
                onClose={store.toggleTest}
            >
                <Input
                    label="Survey"
                    isMandatory
                    onBlur={({ value }) => this.setState({ surveyId: value })}
                />
                {this.renderKpiResult()}
                <ModalFooter>
                    <Button
                        label="Close"
                        cssClass="regular tertiary"
                        onClick={store.toggleTest}
                    />
                    <Button
                        label="Run Test"
                        onClick={this.testKpi}
                        cssClass="regular primary"
                    />
                </ModalFooter>
            </Modal>
        )
    }
}

export default Test
